module.exports = __webpack_public_path__ + "static/img/nongcha.ea0e8b65.png";